<template>
    <div>
        <section class="page-section hide-on-small-and-down show-on-medium-and-up" id="timeline-progress-section">
            <div class="container" style="position: relative">
                <div class="timeline">
                    <div
                        v-for="(date, index) in timeline.time"
                        :key="`timeline_date_${index}`"
                        class="timeline-point"
                        @click="() => selectTimeline(index)"
                    >
                        <!--Inactive timeline image-->
                        <div
                        v-if="index !== timeline.selected"
                        class="timeline-icon"
                        :style="{
                            backgroundImage:
                            'url(' +
                             require('@/assets/images/Belfast/Timeline/Timeline' +
                                          date.header +
                                          '.png') +
                                        ')',
                        }"
                        ></div>
                        <!--Active timeline image-->
                        <div
                        v-if="index === timeline.selected"
                        class="timeline-icon active"
                        :style="{
                            backgroundImage:
                            'url(' +
                             require('@/assets/images/Belfast/Timeline/Timeline' +
                                          date.header +
                                          '.png') +
                                        ')',
                        }"
                        ></div>
                        <!--Inactive progress points-->
                        <div v-if="index > timeline.selected" class="progress-point"></div>
                        <!--Passed progress points-->
                        <div
                        v-if="index < timeline.selected"
                        class="progress-point active"
                        ></div>
                        <!--Active progress points-->
                        <div
                        v-if="index === timeline.selected"
                        class="progress-check active"
                        >
                        <i class="fas fa-check"></i>
                        </div>
                        <!--Inactive header-->
                        <h2 v-if="index !== timeline.selected">{{ date.header }}</h2>
                        <!--Active header-->
                        <h2 v-if="index === timeline.selected" class="active">
                        {{ date.header }}
                        </h2>
                    </div>
                </div>
                <div class="timeline-progress">
                    <div class="bar"></div>
                    <div id="timeline-fill" class="bar fill"></div>
                </div>
                <div class="section-card section-card-timeline">
                <h2>
                    <i class="fas fa-check"></i>
                    {{ timeline.time[timeline.selected].header }}
                </h2>
                <p v-html="timeline.time[timeline.selected].text">
                  
                </p>
                </div>
        </div>
    </section>

    <!--Timeline Section-->
    <!--When screen width is medium-large-->
            <section class="page-section show-on-med-and-down hide-on-med-and-up">
                <div class="container">
                
                    <div class="card-space boxes">
                    <div
                        class="card card-timeline"
                        v-for="(date, index) in timeline.time"
                        :key="`timeline_card_${index}`"
                    >

                    
                        <div
                        class="img "
                        :style="{
                            backgroundImage:
                            'url(' +
                             require('@/assets/images/Belfast/Timeline/Timeline' +
                                          date.header +
                                          '.png') +
                                        ')',
                    
                        }"
                        ></div>
                        <div class="timeline-card-text">
                        <h2>{{ date.header }}</h2>
                        <div v-html="date.text"></div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        </div>
</template>
<script>

export default {
  name: "timeline",
  data() {
    return {
     
      timeline: {
        selected: 0,
        time: [
          {
            header: "2018",
            subheader: "August",
            text:"<h5>August</h5><p>Strategic Outline Case for BRT2 submittedto Belfast Region City Deal</p><h5>September</h5><p>BRT1 pilot network and service opened on 3rd September 2018 under the Glider brand</p><h5>October</h5><p>Belfast Rapid Transit included in the Heads of Terms for Belfast Region City Deal</p>",
          },          
         
          {
            header: "2019",
            subheader: "August",
            text: "Funding secured for scheme development for BelfastRapid Transit Phase 2",
          },
          {
            header: "2020",
            subheader: "June",
            text:"Interim Outline Business Case submitted to Belfast Region City Deal",
          },
          {
            header: "2021",
            subheader: "Current",
            text:"Business Case Preparation<h5>Onwards</h5><p>Belfast Region City Deal Funding Decision</p><p>Detailed Design and Subsequent Construction</p>",
          }
        ],
      },
    };
  },
  components: {
   
  },
  methods: {
   
    selectTimeline(index) {
      this.timeline.selected = index;

      this.progressUpdate(index);
    },
    progressUpdate(index) {
      let progress = document.getElementById("timeline-fill");
      let points = document.querySelectorAll(".timeline-point");
      //alert(`at ${index} => ${((index) / (8)) * 100}%`)
      let n = this.timeline.time.length;
      progress.style.width = `${((index) / (n - 1)) * 100}%`;
    },
    
  },

};
</script>